"use client";

import dynamic from "next/dynamic";

import { Paragraph } from "@/components/ui/typography";

import { cn } from "@/lib/utils";

const BottomRightVector = dynamic(() => import("./vectors/bottom-right.svg"));

function ResourceCard({ title, description, icon, as = "div", ...props }) {
  const IconComponent = icon;

  const Component = as;

  return (
    <Component
      data-testid="resource-card"
      className={cn(
        "relative bg-grayscale-input h-auto md:h-30 rounded-xl p-px",
        "overflow-hidden no-underline shadow-lg z-1",
        "before:absolute before:top-1/2 before:left-1/2 before:bg-primary",
        "before:w-[125%] before:h-1/4 before:blur-sm before:-z-1",
        "before:-translate-1/2 before:invisible hover:before:visible",
        "hover:before:animate-spin hover:before:animate-duration-4000"
      )}
      {...props}
    >
      <div
        className="relative flex flex-col md:flex-row bg-primary-foreground p-3 h-full rounded-xl overflow-hidden z-2"
        data-testid="resource-content-wrapper"
      >
        <div className="flex flex-col gap-y-3 w-full md:w-3/5 z-10">
          <Paragraph variant="b3-tight" weight="sb">
            {title}
          </Paragraph>
          <Paragraph variant="b5">{description}</Paragraph>
        </div>

        <IconComponent className="block self-end ml-auto z-2" />
        <BottomRightVector className="absolute bottom-0 right-0 z-1" />
      </div>
    </Component>
  );
}

export default ResourceCard;
